import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createVNode as _createVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["href", "target", "rel"]

import { computed } from "vue";
import DsIcon from "../icon/ds-icon.vue";
import { SvgIcons } from "../icon/types";


export default /*@__PURE__*/_defineComponent({
  __name: 'typography-headline',
  props: {
    type: { default: "floor" },
    tagName: { default: "h3" },
    icon: {},
    href: {},
    isExternal: { type: Boolean, default: false },
    theme: { default: "light" },
    textPosition: { default: "left" },
    isStorybook: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;

const baseClassName = computed(() => `headline-${props.type}`);
const classList = computed(() => {
    const list = [baseClassName.value];
    if (props.icon) list.push(`${baseClassName.value}--icon`);
    if (props.theme === "dark") list.push(`${baseClassName.value}--dark`);
    if (props.textPosition === "left") {
        list.push(`${baseClassName.value}--left`);
    } else if (props.textPosition === "center") {
        list.push(`${baseClassName.value}--center`);
    } else if (props.textPosition === "right") {
        list.push(`${baseClassName.value}--right`);
    }
    return list;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.tagName), {
    class: _normalizeClass(classList.value)
  }, {
    default: _withCtx(() => [
      (_ctx.href)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            class: _normalizeClass(`${baseClassName.value}__link`),
            href: _ctx.href,
            target: _ctx.isExternal ? '_blank' : undefined,
            rel: _ctx.isExternal ? 'noopener noreferrer' : undefined
          }, [
            (_ctx.icon)
              ? (_openBlock(), _createBlock(DsIcon, {
                  key: 0,
                  name: _ctx.icon,
                  "is-in-storybook": props.isStorybook,
                  class: _normalizeClass(`${baseClassName.value}__icon`)
                }, null, 8, ["name", "is-in-storybook", "class"]))
              : _createCommentVNode("", true),
            _renderSlot(_ctx.$slots, "default"),
            _createVNode(DsIcon, { name: "chevron-right" })
          ], 10, _hoisted_1))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_ctx.icon)
              ? (_openBlock(), _createBlock(DsIcon, {
                  key: 0,
                  name: _ctx.icon,
                  "is-in-storybook": props.isStorybook,
                  class: _normalizeClass(`${baseClassName.value}__icon`)
                }, null, 8, ["name", "is-in-storybook", "class"]))
              : _createCommentVNode("", true),
            _renderSlot(_ctx.$slots, "default")
          ], 64))
    ]),
    _: 3
  }, 8, ["class"]))
}
}

})